import { Provider } from "~/core/types/affility/web3/Provider";
import { STATE } from "./names";

export default () => {
    return {
        [STATE.PROVIDER]: null as Provider | null,
    };
};